import React from 'react';
import {googleAnalyticsSimplePageView} from '../utils/google-analytics-utils';

export default class Error5xx extends React.Component<{message:string},{}> {

    componentDidMount() {
        googleAnalyticsSimplePageView();
    }

    render() {
        return (
            <div>
                <link href="/static/css/style.css" type="text/css" rel="stylesheet"></link>
                <div id="header">
                    <table cellSpacing="0" cellPadding="0" width="760" style={{border:'none'}}>
                        <tbody>
                            <tr>
                                <td className="MenuBgcolor">&nbsp;</td>
                            </tr>
                            <tr>
                                <td className="BoxColor2" style={{fontSize: '0'}}>
                                <img height="1" alt="" src="/static/images/image_clearpixel1x1.gif" width="1"/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                <table cellSpacing="0" cellPadding="0" width="100%" style={{border:'none'}}>
                                    <tbody>
                                        <tr>
                                            <td style={{verticalAlign:"middle"}}>&nbsp;&nbsp;<b style={{fontWeight: 'bold',fontFamily:'Arial', color:'#CC0000', fontSize:'18px'}}>Unable to Process Request Notice</b></td>
                                            <td align="right"><a href="http://www.paymentus.com/">
                                            <img height="62" alt="Paymentus Logo" src="/static/images/sm_paymentuslogo.gif" width="158" style={{border:'none'}}/></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </td>
                            </tr>
                            <tr>
                            <td className="BoxColor2" style={{fontSize: '0'}}>
                                <img height="1" alt="" src="/static/images/image_clearpixel1x1.gif" width="1"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                    <div id="main">
                    <p>&nbsp;</p>
                    <p><b style={{fontWeight: 'bold'}}>{this.props.message || 'We are unable to process your request at this time'}</b></p>
                    <p>A problem has occurred in processing your request.</p>
                    <p>Please contact the Administrator.</p>
                    <p>
                        <br/>
                    </p>
                    <div className="clearing"></div>
                    </div>
                    <div></div>
                    <div id="footer">Powered by Paymentus - The most effective way to pay.
                </div>
            </div>
        );
    }
}
